// extracted by mini-css-extract-plugin
export default {"container":"BW1J0T","text":"IcCEGy","spinner":"MLFJ4i"};